import axios from 'axios';
import { PropertyImportExclusion } from '../../types/PropertyImportExclusion';

class PropertyImportExclusionsService {
  async getAll(): Promise<PropertyImportExclusion[]> {
    const result = await axios.get('/property-import-exclusions');
    return result.data.map(mapFromApiResponse);
  }

  async get(id: string): Promise<PropertyImportExclusion> {
    const result = await axios.get(`/property-import-exclusions/${id}`);
    return result.data && mapFromApiResponse(result.data);
  }

  async delete(id: string): Promise<void> {
    return axios.delete(`/property-import-exclusions/${id}`);
  }

  async create(postData: PropertyImportExclusion): Promise<void> {
    return axios.post(`/property-import-exclusions`, mapToRequestBody(postData));
  }

  async edit(postData: PropertyImportExclusion, id: string): Promise<void> {
    return axios.put(`/property-import-exclusions/${id}`, mapToRequestBody(postData));
  }
}

const mapFromApiResponse = (propertyImportExclusion: any): PropertyImportExclusion => {
  return {
    ...propertyImportExclusion,
  };
};

const mapToRequestBody = (propertyImportExclusion: PropertyImportExclusion): any => {
  const result = {
    id: propertyImportExclusion.id,
    name: propertyImportExclusion.name,
  };

  return result;
};

const propertyImportExclusionsService = new PropertyImportExclusionsService();
export default propertyImportExclusionsService;
